import axios from "axios";

const fetchDataFromGitHub = async () =>
{
    try
    {
        const response = await axios.get(process.env.REACT_APP_GITHUB_API_URL + process.env.REACT_APP_GITHUB_USERNAME + "/repos");
        return response.data;
    } catch (error)
    {
        console.error("Error fetching data:", error);
        throw error;
    }
};

const fetchDataFromBlogger = async () =>
{
    try
    {
        const response = await axios.get(`https://www.googleapis.com/blogger/v3/blogs/${process.env.REACT_APP_BLOGGER_BLOG_ID}/posts?key=${process.env.REACT_APP_BLOGGER_API_KEY}&maxResults=100`);
        return response.data;
    } catch (error)
    {
        console.error("Error fetching data:", error);
        throw error;
    }
};

const fetchDataFromMedium = async () =>
{
     try
    {
        const res = await axios.get("/medium-feed", { responseType: "text" });
        const xml = new DOMParser().parseFromString(res.data, "text/xml");

        const items = Array.from(xml.getElementsByTagName("item")).map((item) =>
        {
            const get = (tag) => item.getElementsByTagName(tag)[0]?.textContent || "";
            const content = get("content:encoded");
            const img = content.match(/<img[^>]+src="([^"]+)"/);
            return {
                title: get("title"),
                link: get("link"),
                guid: get("guid"),
                pubDate: get("pubDate"),
                author: get("dc:creator"),
                thumbnail: img ? img[1] : "",
                description: content,
                content,
                categories: Array.from(item.getElementsByTagName("category")).map((c) => c.textContent),
            };
        });

        return { status: "ok", items };
    } catch (error)
    {
        console.error("Error fetching data:", error);
        throw error;
    }
};

const fetchDataFromServer = async (url) =>
{
    try
    {
        const response = await axios.get(process.env.REACT_APP_BASE_URL + url);
        return response.data;
    } catch (error)
    {
        console.error("Error fetching data:", error);
        throw error;
    }
};


const api = {
    fetchDataFromGitHub,
    fetchDataFromBlogger,
    fetchDataFromMedium,
    fetchDataFromServer
};

export default api;
